import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    CatalogComponent,
    catalogRoute,
    OnlineCatalogService,
} from '.';

let ENTITY_STATES = [
    ...catalogRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        CatalogComponent,
    ],
    entryComponents: [
        CatalogComponent,
    ],
    providers: [
        OnlineCatalogService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiCatalogModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/catalog/catalog.module.ts